import { LABEL_DEFAULTS, POINT_DEFAULTS, LINE_DEFAULTS, POLYGON_DEFAULTS } from '../primitives/primitive.model';
import type { FeatureTheme } from './feature-style.model';
import { AMPLITUDE_DEFAULTS } from './amplitude';
import { ASYMPTOTES_DEFAULTS } from './asymptotes';
import { AXIS_OF_SYMMETRY_DEFAULTS } from './axis-of-symmetry';
import { DERIVATIVE_DEFAULTS } from './derivative';
import { DOMAIN_DEFAULTS } from './domain';
import { RANGE_DEFAULTS } from './range';
import { EXTREMA_DEFAULTS } from './extrema';
import { FUNCTION_AREA_DEFAULTS } from './function-area';
import { HANDLE_DEFAULTS } from './handle';
import { INFLECTION_DEFAULTS } from './inflection';
import { INTERSECTION_DEFAULTS } from './intersection';
import { INTERSECTION_AREA_DEFAULTS } from './intersection-area';
import { MONOTONICITY_DEFAULTS } from './monotonicity';
import { PERIOD_DEFAULTS } from './period';
import { PHASE_SHIFT_DEFAULTS } from './phase-shift';
import { ROOTS_DEFAULTS } from './roots';
import { SECANT_DEFAULTS } from './secant';
import { TANGENT_DEFAULTS } from './tangent';
import { TRAJECTORY_DEFAULTS } from './trajectory';
import { WAVELENGTH_DEFAULTS } from './wavelength';
import { Y_INTERCEPT_DEFAULTS } from './y-intercept';

/**
 * Default feature theme with sensible defaults for all feature types.
 *
 * Style propagation order:
 * 1. ElementTheme.point (global default from elements/)
 * 2. FeatureTheme[featureType] (feature node)
 * 3. FeatureTheme[featureType].subparts[subpart] (subpart node)
 * 4. display.elements[elementId] (instance node)
 * 5. display.elements[elementId].subparts[subpart] (instance subpart)
 */
export const DEFAULT_FEATURE_THEME: FeatureTheme = {
  label: LABEL_DEFAULTS,
  point: POINT_DEFAULTS,
  line: LINE_DEFAULTS,
  polygon: POLYGON_DEFAULTS,
  amplitude: AMPLITUDE_DEFAULTS,
  asymptotes: ASYMPTOTES_DEFAULTS,
  axisOfSymmetry: AXIS_OF_SYMMETRY_DEFAULTS,
  derivative: DERIVATIVE_DEFAULTS,
  domain: DOMAIN_DEFAULTS,
  range: RANGE_DEFAULTS,
  extrema: EXTREMA_DEFAULTS,
  functionArea: FUNCTION_AREA_DEFAULTS,
  handle: HANDLE_DEFAULTS,
  inflection: INFLECTION_DEFAULTS,
  intersection: INTERSECTION_DEFAULTS,
  intersectionArea: INTERSECTION_AREA_DEFAULTS,
  monotonicity: MONOTONICITY_DEFAULTS,
  period: PERIOD_DEFAULTS,
  phaseShift: PHASE_SHIFT_DEFAULTS,
  roots: ROOTS_DEFAULTS,
  secant: SECANT_DEFAULTS,
  tangent: TANGENT_DEFAULTS,
  trajectory: TRAJECTORY_DEFAULTS,
  wavelength: WAVELENGTH_DEFAULTS,
  yIntercept: Y_INTERCEPT_DEFAULTS,
};

// Re-export core types and utilities
export * from './feature.model';
export * from './feature-style.model';

// Re-export feature implementations
export * from './amplitude';
export * from './asymptotes';
export * from './axis-of-symmetry';
export * from './derivative';
export * from './domain';
export * from './range';
export * from './extrema';
export * from './feature.registry';
export * from './function-area';
export * from './handle';
export * from './inflection';
export * from './intersection';
export * from './intersection-area';
export * from './monotonicity';
export * from './period';
export * from './phase-shift';
export * from './roots';
export * from './secant';
export * from './tangent';
export * from './trajectory';
export * from './wavelength';
export * from './y-intercept';
